export default __webpack_public_path__ + "static/media/cryptobook.8e2539bd.jpg";